// Reconstructed from the supplied production build; original component names were unavailable.
import { Helmet } from "../vendor/runtime.js";
const Seo = () => (
  <Helmet>
    <title>{"Final Year Projects for CSE, IT, BCA, ECE, EEE with Source Code | CodeBruh"}</title>
    <meta
      name={"description"}
      content={
        "CodeBruh offers ready-made final year projects with full source code for CSE, IT, BCA, ECE, and EEE students. Learn with AI-powered explanations. Trusted by thousands of students."
      }
    />
    <meta
      name={"keywords"}
      content={
        "codebruh, code bro, codebro, final year projects, CSE projects, IT projects, BCA final year project, ECE major projects, EEE final year project, final year project with source code, academic projects, AI project tutor, engineering projects"
      }
    />
    <link rel={"canonical"} href={"https://codebruh.kestroinfotech.com/"} />
    <link rel={"icon"} type={"image/png"} href={"/Logo.webp"} />
    <meta
      property={"og:title"}
      content={"Final Year Projects for Engineering Students | CodeBruh"}
    />
    <meta
      property={"og:description"}
      content={
        "Get AI-powered final year projects for CSE, IT, BCA, ECE, and EEE with source code. Simple, clear, and effective — just like CodeBruh."
      }
    />
    <meta property={"og:url"} content={"https://codebruh.kestroinfotech.com/"} />
    <meta property={"og:type"} content={"website"} />
    <meta property={"og:image"} content={"https://codebruh.kestroinfotech.com/Logo.webp"} />
    <meta name={"twitter:card"} content={"summary_large_image"} />
    <meta name={"twitter:title"} content={"Final Year Projects with AI Tutor | CodeBruh"} />
    <meta
      name={"twitter:description"}
      content={
        "Final year projects for all branches — CSE, BCA, ECE, EEE, and IT — with full source code and AI explanation. For College Students, By College Students."
      }
    />
    <meta name={"twitter:image"} content={"https://codebruh.kestroinfotech.com/Logo.webp"} />
    <script type={"application/ld+json"}>
      {JSON.stringify({
        "@context": "https://schema.org",
        "@type": "Organization",
        name: "CodeBruh",
        url: "https://codebruh.kestroinfotech.com",
        alternateName: ["CodeBro", "Code Bro", "codebro", "code bruh"],
        logo: "https://codebruh.kestroinfotech.com/Logo.webp",
        description:
          "Final year projects for CSE, IT, BCA, ECE, and EEE with source code and AI explanations. India's trusted academic project platform.",
        sameAs: [
          "https://www.instagram.com/codebruh.in",
          "https://www.linkedin.com/company/codebruh",
          "https://twitter.com/codebruh",
        ],
      })}
    </script>
  </Helmet>
);
export { Seo };
